/**
 * Toast UI — a transient banner overlay. Lives on the top-level shell
 * document (the launcher window). Module iframes can request a toast by
 * calling window.Shell.showToast(), which crosses the frame boundary via
 * window.parent.postMessage({ type: 'shell.toast', msg }).
 */

let container: HTMLDivElement | null = null;

function ensureContainer(): HTMLDivElement {
  if (container) return container;
  container = document.createElement('div');
  container.id = 'shell-toast-container';
  container.style.cssText = [
    'position:fixed',
    'left:50%',
    'bottom:24px',
    'transform:translateX(-50%)',
    'z-index:2147483647',
    'display:flex',
    'flex-direction:column',
    'gap:8px',
    'pointer-events:none',
    'font-family:system-ui,sans-serif',
  ].join(';');
  document.body.appendChild(container);
  return container;
}

export function showToast(msg: string): void {
  const root = ensureContainer();
  const el = document.createElement('div');
  el.textContent = msg;
  el.style.cssText = [
    'background:rgba(20,20,20,0.92)',
    'color:#fff',
    'padding:10px 16px',
    'border-radius:8px',
    'font-size:14px',
    'box-shadow:0 4px 12px rgba(0,0,0,0.3)',
    'opacity:0',
    'transform:translateY(8px)',
    'transition:opacity 180ms,transform 180ms',
    'max-width:80vw',
  ].join(';');
  root.appendChild(el);
  requestAnimationFrame(() => {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  });
  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(8px)';
    setTimeout(() => el.remove(), 220);
  }, 2400);
}
